import unit1 from "../assets/unit1.png";
import unit2 from "../assets/unit3.png";
import unit3 from "../assets/unit2.png";
import unit4 from "../assets/unit4.png";
import unit5 from "../assets/unit5.png";
import unit6 from "../assets/unit6.png";
import unit7 from "../assets/unit7.png";
import unit8 from "../assets/unit8.png";
import unit9 from "../assets/unit9.png";
import unit10 from "../assets/unit10.png";
import unit11 from "../assets/unit11.png";
import unit12 from "../assets/unit12.png";

export default function Unit() {
  return (
    <>
      <style>
        {`
          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
      <section className="text-gray-600 body-font">
        <div className="container px-5 py-2 mx-auto">
          <h1
            className="
              sm:text-3xl text-center text-2xl font-medium title-font mb-4 text-gray-900
              opacity-0 animate-[fadeInUp_1s_ease-out_forwards]
            "
          >
            Persebaran Unit Satuan Pelayanan Pemenuhan Gizi <br /> Kota Depok
          </h1>
          <br /> <br />
          <div className="flex flex-wrap -m-4">
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.1s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit1} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Margonda Raya No. 128, Beji,<br /> Depok 16424
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Margonda</h2>
                <p className="mt-0">no HP: <strong>088900876438</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.2s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit2} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Raya Sawangan No. 45, Pancoran Mas, <br /> Depok 16436
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium"> Menangani sekolah daerah Sawangan</h2>
                <p className="mt-0">no HP: <strong>088170876438</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.3s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit3} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Tole Iskandar No. 72, Sukmajaya,<br /> Depok 16412
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Sukmajaya</h2>
                <p className="mt-0">no HP: <strong>088170876893</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.4s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit4} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Cinere Raya No. 10, Cinere,<br /> Depok 16514
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Cinere</h2>
                <p className="mt-0">no HP: <strong>08817946893</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.5s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit5} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Raya Bogor KM 30, Cimanggis,<br /> Depok 16451
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Cimanggis</h2>
                <p className="mt-0">no HP: <strong>08217974893</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.6s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit6} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Keadilan No. 23, Kalimulya, Cilodong,<br /> Depok 16413
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Cilodong</h2>
                <p className="mt-0">no HP: <strong>0859266893</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.7s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit7} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Raya Kukusan No. 88, Beji, <br /> Depok 16425
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Kukusan</h2>
                <p className="mt-0">no HP: <strong>08542946893</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.8s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit8} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Krukut Raya No. 19, Limo,<br /> Depok 16512
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Krukut Raya</h2>
                <p className="mt-0">no HP: <strong>08817947609</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "0.9s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit12} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Abdul Wahab No. 65, Sawangan Baru, Sawangan,<br /> Depok 16511
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Sawangan Baru</h2>
                <p className="mt-0">no HP: <strong>08817933193</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.0s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit10} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Mandor Samin No. 14, Rangkapan Jaya, Pancoran Mas,<br /> Depok 16435
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Pancoran Mas</h2>
                <p className="mt-0">no HP: <strong>08217974893</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.1s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit11} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Raya Muchtar No. 21, Sawangan Lama,<br /> Depok 16511
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Sawangan Baru</h2>
                <p className="mt-0">no HP: <strong>0859266222</strong></p>
              </div>
            </div>
            <div
              className="lg:w-1/4 md:w-1/2 p-4 w-full opacity-0 animate-[fadeInUp_0.8s_ease-out_forwards]"
              style={{ animationDelay: "1.2s" }}
            >
              <a className="block relative h-48 rounded overflow-hidden">
                <img className="object-cover object-center w-full h-full block" src={unit9} />
              </a>
              <div className="mt-4">
                <h3 className="text-gray-500 text-xs tracking-widest title-font mb-1">
                  Jl. Raya Kukusan No. 88, Beji, <br /> Depok 16425
                </h3>
                <h2 className="text-gray-900 title-font text-lg font-medium">Menangani sekolah daerah Kukusan</h2>
                <p className="mt-0">no HP: <strong>08542946893</strong></p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
